import React from 'react';
import {FilterType} from "../data/FilterList";

export default function FilterItem({handleFilterToggle, filter}: {handleFilterToggle: Function, filter: FilterType}) {
    return (
        <li>
            <div className="checkbox-wrapper-6">
                <input className={`tgl tgl-light`} checked={filter.active}  onChange={() => handleFilterToggle(filter.id)} id={filter.id} type="checkbox"/>
                <label className="tgl-btn" htmlFor={filter.id}></label>
                <span className={'filter-label'}>{filter.name}</span>
            </div>
        </li>
)
}